import React, { useEffect, useState } from "react";
import {
  fetchWantProducts,
  deleteWantProduct,
  updateWantProduct,
  createWantProduct,
} from "../../apiComponents/api-products";

import WantProductTable from "../../ui/WantProductTable";
import WantProductForm from "../../ui/WantProductForm";
import WantProductEditModal from "../../ui/WantProductEditModal";
import Button from "../../ui/Button";

const WantMenuManagementPage = () => {
  const [wantedProducts, setWantedProducts] = useState([]);

  const [editingProduct, setEditingProduct] = useState(null);

  const [addingNew, setAddingNew] = useState(false);

  const [newProductData, setNewProductData] = useState({
    name: "",
    budget: "",
    description: "",
    contact_phone: "",
    contact_whatsapp: "",
    location: "swellendam",
    is_active: true,
  });

  const [saving, setSaving] = useState(false);

  const loadProducts = async () => {
    const data = await fetchWantProducts();

    if (data) {
      setWantedProducts(data);
    }
  };

  useEffect(() => {
    loadProducts();
  }, []);

  const handleAddProduct = async () => {
    try {
      setSaving(true);

      await createWantProduct({
        name: newProductData.name,
        budget: newProductData.budget,
        description: newProductData.description,
        contact_phone: newProductData.contact_phone,
        contact_whatsapp: newProductData.contact_whatsapp,
        location: newProductData.location,
        is_active: newProductData.is_active,
      });

      setAddingNew(false);

      setNewProductData({
        name: "",
        budget: "",
        description: "",
        contact_phone: "",
        contact_whatsapp: "",
        location: "swellendam",
        is_active: true,
      });

      await loadProducts();

    } catch (error) {
      console.error("Error adding wanted product:", error);
      alert("Something went wrong while creating the wanted listing.");
    } finally {
      setSaving(false);
    }
  };

  const handleSaveEdit = async (id, updatedData) => {
    await updateWantProduct(id, updatedData);

    setEditingProduct(null);

    await loadProducts();
  };

  return (
    <div className="p-4 md:p-10 max-w-7xl mx-auto">

      <h1 className="text-2xl md:text-3xl font-bold text-center mb-6">
        Wanted Products Management
      </h1>

      {!addingNew && (
        <Button onClick={() => setAddingNew(true)}>
          Add Wanted Item
        </Button>
      )}

      {addingNew && (
        <WantProductForm
          form={newProductData}

          onChange={(e) =>
            setNewProductData({
              ...newProductData,
              [e.target.name]: e.target.value,
            })
          }

          onSubmit={handleAddProduct}

          onCancel={() => setAddingNew(false)}

          loading={saving}
        />
      )}

      <WantProductTable
        products={wantedProducts}

        onEdit={(product) =>
          setEditingProduct(product)
        }

        onDelete={async (id) => {
          await deleteWantProduct(id);
          await loadProducts();
        }}
      />

      <WantProductEditModal
        product={editingProduct}
        onClose={() => setEditingProduct(null)}
        onSave={handleSaveEdit}
      />

    </div>
  );
};

export default WantMenuManagementPage;